/* eslint-disable no-duplicate-imports, react-hooks/exhaustive-deps, no-unused-vars, no-dupe-keys */
import React, { useState, useEffect, useMemo, useCallback, useContext, useRef } from "react";
import { CircularProgress, Drawer, Chip, Box } from "@mui/material";
import { styled } from '@mui/material/styles'
import { SelectedAlertsContext } from "../../../utils/SelectedAlertContext";
import Multiselectwithsearchinput from "../../components/dropdown/MultiSelectWithInput";
import { exportToExcelFile } from "../../api/api";
import { ListItem } from "@mui/material";
import SnackBarMessage from "../../components/snackbar/snackbar";
import AlertRmpmKpi from "../../components/Cards/AlertKPI";
import ReviewCart from "./reviewCart";
import ActionPopup from "../../../Samarth Module/components/popup/actionPopup";
import Filters from "../../../assets/images/filters.svg";
import Excel from "../../../assets/images/Excel.svg";
import Slider from "../../../assets/images/sliders 1.svg";
import CustomiseColumns from "../../../Samarth Module/components/drawers/CustomiseColumns";
import MoreFilters from "../../../Samarth Module/components/drawers/moreFilters";
import { getAlertConfig } from "../../constants/alertConfig";
import CustomButton from "../../components/buttons/CustomButton";
import styles from "./alert.module.css";
import { generateKPIDetails } from "utils/generateKPIDetails";
import PropTypes from 'prop-types';
import clsx from 'clsx';
import resetBtn from "../../../assets/images/resetBtn.png";
import OverflowMenu from "Samarth Module/components/overflowMenu/OverflowMenu";
import { useMsal } from "@azure/msal-react";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ChatBot from '../../components/chatbot/ChatBot';

const MAI_VIEW = "MAI View";
const ABSOLUTE_VIEW = "Absolute";

const getWeekFromAlertId = (alertId = "") => alertId.split("-").slice(0, 2).join("-");

const getFilterableValues = (value) => {
  if (value === undefined || value === null) return [];
  if (typeof value === 'string' && value.includes(',')) {
    return value.split(',').map((item) => item.trim());
  }
  return [value];
};

const sortUniqueValues = (values) =>
  [...new Set(values)].sort((a, b) => String(a).localeCompare(String(b)));

const hasSelectedValues = (selected) => {
  if (Array.isArray(selected)) return selected.length > 0;
  if (typeof selected === 'string') return selected.trim().length > 0;
  return selected !== undefined && selected !== null;
};

const hasAnyFilterSelection = (filters = []) =>
  filters.some((filter) => hasSelectedValues(filter?.selectedData));

const removeArrayItemAtIndex = (values, indexToRemove) => {
  if (!Array.isArray(values)) return [];
  return values.slice(0, indexToRemove).concat(values.slice(indexToRemove + 1));
};

const buildFilterData = (data, filter) => {
  if (filter.label === "Week") {
    const weekValues = [...new Set(data.map((item) => getWeekFromAlertId(item["Alert ID"])))];
    return weekValues.sort((a, b) => {
      const [fyA, weekA] = a.split("-");
      const [fyB, weekB] = b.split("-");
      return fyA === fyB ? parseInt(weekA, 10) - parseInt(weekB, 10) : fyA.localeCompare(fyB);
    });
  }

  const allValues = data.flatMap((item) => getFilterableValues(item[filter.label]));
  return sortUniqueValues(allValues);
};

const refreshFilterOptions = (filters, data) =>
  filters.map((filter) => {
    if (filter.selectedData?.length) return filter;
    return { ...filter, data: buildFilterData(data, filter) };
  });

const applySelectedFilters = (data, filters) =>
  data.filter((item) =>
    filters.every((filter) => {
      if (!filter.selectedData?.length) return true;

      const itemValue = item[filter.label];
      if (itemValue === undefined || itemValue === null) return false;

      if (filter.label === "Week") {
        return filter.selectedData.includes(getWeekFromAlertId(item["Alert ID"]));
      }

      return getFilterableValues(itemValue).some((value) => filter.selectedData.includes(value));
    })
  );

const AlertLanding = ({ alertType }) => {
  const { kpiDetails: initialKpiDetails, uiConfig, apiConfig } = getAlertConfig(alertType);
  const kpiDetails = useMemo(() => initialKpiDetails, [alertType]);
  const shouldUseContext = ['RMPM Alert', 'Agile OR', 'Contract Alert'].includes(alertType);
  const { accounts } = useMsal();
  const activeAccount = accounts[0] || null;

  const {
    alertDetailsData,
    setAlertDetailsData,
    selectedAlertAndRecomm,
    setSelectedAlerts,
    selectedAlerts,
    setSelectedAlertAndRecomm
  } = useContext(SelectedAlertsContext);

  const [state, setState] = useState({
    loading: true,
    drawerState: false,
    isDrawerOpen: false,
    filterDrawer: false,
    openPopup: false,
    filteredData: [],
    maiDetailsData: [],
    maiFilteredData: [],
    maiDetailsColumns: [],
    maiFilters: [],
    rmpmFilters: [],
    excelLoading: false,
    p2AlertCount: 0,
    defaultColumns: [],
    columnList: [],
    ContractAvailableCount: 0,
    PRtoPOConversion: 0,
    supplierInsights: [],
    vendorQCIndex: [],
    overduePO: [],
    leadTimeAnalysis: [],
    sobCompliance: [],
    weekNum: [],
    segmentationCounts: 0,
    priorityCounts: 0,
    percentages: []
  });

  const [viewType, setViewType] = useState(uiConfig.showToogleButton ? uiConfig.toggleBtn[0] : '');
  const [snackBarObject, setSnackBarObject] = useState({
    snackbarOpen: false,
    message: '',
    type: 'error'
  });
  const isMAIView = viewType === MAI_VIEW;
  const isTableComponent2View = isMAIView || viewType === ABSOLUTE_VIEW;
  const table2Data = isMAIView ? state.maiFilteredData : state.filteredData;
  const table2Columns = isMAIView ? state.maiDetailsColumns : state.defaultColumns;
  const clearFiltersRef = useRef(false);

  const alertDetails = useCallback(() => {
    return shouldUseContext ? alertDetailsData : state.alertDetailsData;
  }, [shouldUseContext, alertDetailsData, state.alertDetailsData]);

  const selectedRecomLength = useMemo(
    () => selectedAlertAndRecomm?.reduce((acc, item) => acc + (item?.selectedRecom?.length || 0), 0),
    [selectedAlertAndRecomm]
  );

  const kpiData = useMemo(() => {
    if (!uiConfig.showKPI) return null;
    const po_count = state?.filteredData.reduce((sum, item) => sum + item["PO Count"], 0); 
    const pr_count = state?.filteredData.reduce((sum, item) => sum + item["PR Count"], 0); 
    return generateKPIDetails({
      kpiDetails,
      filteredData: state?.filteredData,
      p2AlertCount: state?.p2AlertCount,
      alertType,
      ContractAvailableCount: state.ContractAvailableCount,
      PRtoPOConversion: pr_count?Math.ceil((po_count / pr_count) * 100):0,
      percentages: state?.percentages,
    });
  }, [kpiDetails, state.p2AlertCount, state.ContractAvailableCount, state.PRtoPOConversion, JSON.stringify(state.filteredData)]);

  const TableComponent = useMemo(() => apiConfig.tableComponent, [apiConfig.tableComponent]);
  const TableComponent2 = useMemo(() => apiConfig.tableComponent2, [apiConfig.tableComponent2]);

  const fetchData = useCallback(async () => {
    const shouldClearFilters = clearFiltersRef.current;
    clearFiltersRef.current = false;
    
    try {
      setState(prev => ({ ...prev, loading: true }));
      if (!apiConfig.apiFunction) {
        throw new Error(`No API function defined for alert type: ${alertType}`);
      }

      const data = await apiConfig.apiFunction(
        activeAccount.username,
        alertType,
        activeAccount?.idTokenClaims?.roles,
        viewType
      );

      if (shouldUseContext) {
        setAlertDetailsData(data?.alertDetails || []);
      }

      setState(prev => ({
        ...prev,
        p2AlertCount: data?.P2_Alert_Count || 0,
        alertDetailsData: data?.alertDetails || [],
        maiDetailsData: data?.maiDetails || [],
        maiFilteredData: data?.maiDetails || [],
        maiDetailsColumns: data?.maiColumns || [],
        maiFilters: data?.maiFilter || [],
        filteredData: data?.alertDetails || [],
        defaultColumns: data?.defaultColumns || [],
        rmpmFilters: data?.filters || [],
        loading: false,
        columnList: data?.defaultColumns || [],
        ContractAvailableCount: data?.ContractAvailableCount || 0,
        PRtoPOConversion: data?.PR_to_PO_conversion || 0,
        supplierInsights: data?.supplierInsights || [],
        vendorQCIndex: data?.vendorQCIndex || [],
        overduePO: data?.overduePO || [],
        leadTimeAnalysis: data?.leadTimeAnalysis || [],
        sobCompliance: data?.sobCompliance || [],
        weekNum: data?.weekColumns || [],
        segmentationCounts: data?.segmentationCounts || 0,
        priorityCounts: data?.priorityCounts || 0,
        percentages: data?.aggregatedRootCauses?.percentages || [],
      }));
    } catch (error) {
      setSnackBarObject({
        snackbarOpen: true,
        message: "An error occurred while fetching data. Please refresh or try again ",
        type: 'error'
      });
      setState(prev => ({ ...prev, loading: false }));
    }
  }, [alertType, apiConfig.apiFunction]);

  useEffect(() => {
    if (isMAIView) return;
    if (!state.filteredData.length) return;
    const updatedRMPMFilters = refreshFilterOptions(state.rmpmFilters, state.filteredData);

    const filtersChanged = updatedRMPMFilters.some((filter, i) =>
      JSON.stringify(filter) !== JSON.stringify(state.rmpmFilters[i])
    );

    if (filtersChanged) {
      setState(prev => ({ ...prev, rmpmFilters: updatedRMPMFilters }));
    }
  }, [isMAIView, state.filteredData, state.rmpmFilters]);

  useEffect(() => {
    if (!isMAIView) return;
    if (!state.maiDetailsData.length) return;

    const updatedMAIFilters = refreshFilterOptions(state.maiFilters, state.maiFilteredData);

    const filtersChanged = updatedMAIFilters.some((filter, i) =>
      JSON.stringify(filter) !== JSON.stringify(state.maiFilters[i])
    );

    if (filtersChanged) {
      setState(prev => ({ ...prev, maiFilters: updatedMAIFilters }));
    }
  }, [isMAIView, state.maiDetailsData, state.maiFilteredData, state.maiFilters]);

  useEffect(() => {
    if (isMAIView) return;
    const sourceData = alertDetails();
    if (!sourceData) return;

    const updatedFilteredData = applySelectedFilters(sourceData, state.rmpmFilters);

    if (JSON.stringify(updatedFilteredData) !== JSON.stringify(state.filteredData)) {
      setState(prev => ({ ...prev, filteredData: updatedFilteredData }));
    }
  }, [isMAIView, state.rmpmFilters, alertDetailsData, state.alertDetailsData]);

  // Apply filters (MAI view)
  useEffect(() => {
    if (!isMAIView) return;
    if (!state.maiDetailsData.length) return;

    const updatedFilteredData = applySelectedFilters(state.maiDetailsData, state.maiFilters);

    if (JSON.stringify(updatedFilteredData) !== JSON.stringify(state.maiFilteredData)) {
      setState(prev => ({ ...prev, maiFilteredData: updatedFilteredData }));
    }
  }, [isMAIView, state.maiFilters, state.maiDetailsData, state.maiFilteredData]);

  const handleMultiSelectChange = useCallback((label, values, isMAI = false) => {
    const filterKey = isMAI ? 'maiFilters' : 'rmpmFilters';
    setState(prev => {
      const updatedFilters = prev[filterKey].map(filter =>
        filter.label === label ? { ...filter, selectedData: values } : filter
      );

      clearFiltersRef.current = !hasAnyFilterSelection(updatedFilters);
      
      return {
        ...prev,
        [filterKey]: updatedFilters
      };
    });
  }, []);

  const exportToExcel = useCallback(async () => {
    try {
      setState(prev => ({ ...prev, excelLoading: true }));
      const dataToExport = viewType === 'MAI View' ? state.maiFilteredData : state.filteredData;
      await exportToExcelFile(dataToExport);
    } catch (error) {
      setSnackBarObject({ snackbarOpen: true, message: error.message, type: 'error' });
    } finally {
      setState(prev => ({ ...prev, excelLoading: false }));
    }
  }, [state.filteredData, state.maiFilteredData, viewType]);

  const toggleDrawer = useCallback((open) => () => {
    if (selectedRecomLength === 0) return;
    setState(prev => ({ ...prev, drawerState: open }));
  }, [selectedRecomLength]);

  const handleSubmit = useCallback(async () => {
    setState(prev => ({ ...prev, openPopup: true }));
  }, [selectedRecomLength, selectedAlertAndRecomm, selectedAlerts, setSelectedAlerts, setSelectedAlertAndRecomm]);

  const handleCustomizeDrawer = useCallback(() => {
    setState(prev => ({ ...prev, isDrawerOpen: !prev.isDrawerOpen }));
  }, []);

  const columnCustomization = useCallback((list) => {
    const target = viewType === 'MAI View' ? 'maiDetailsColumns' : 'columnList';
    setState(prev => ({ ...prev, [target]: list, isDrawerOpen: false }));
  }, [viewType]);

  const handleFilterDrawer = useCallback(() => {
    setState(prev => ({ ...prev, filterDrawer: !prev.filterDrawer }));
  }, []);

  const closeSnackbar = useCallback(() => {
    setSnackBarObject({ message: '', snackbarOpen: false, type: 'error' });
  }, []);

  const handleToggleBtnChange = (event, newViewType) => {
    if (newViewType !== null) {
      setViewType(newViewType);
    }
  };

  const resetFilter = () => {
    clearFiltersRef.current = true;
    const targetFilterKey = isMAIView ? 'maiFilters' : 'rmpmFilters';
    const clearedFilters = state[targetFilterKey].map((filter) => ({
      ...filter,
      selectedData: []
    }));

    setState((prev) => ({
      ...prev,
      [targetFilterKey]: clearedFilters
    }));
  };

  const updateFiltersFromDrawer = useCallback((filters) => {
    clearFiltersRef.current = !hasAnyFilterSelection(filters);
    setState((prev) => ({
      ...prev,
      [isMAIView ? "maiFilters" : "rmpmFilters"]: filters,
    }));
  }, [isMAIView]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  if (state.loading) {
    return <div className={styles.loaderContainer}><CircularProgress /></div>;
  }

  const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
      fontSize: "12px",
      fontWeight: 400,
      padding: "3px 5px",
      textTransform: "none",
      width: "9rem",
      color: "#2B2B2B",
      '&:hover': {
        background: "transparent",
      }
    },
    '& .MuiToggleButtonGroup-grouped.Mui-selected': {
      background: "#1F36C7",
      color: "white",
      '&:hover': {
        background: "#1F36C7",
        color: "white"
      }
    }
  }));

  const weekColFilter = (label, data) => {
    console.log(label, data)
  }
  return (
    <>
      {uiConfig.showKPI && (
        <div className={styles.kpiContainer}>
          <AlertRmpmKpi KPIObj={kpiData} type={alertType} />
        </div>
      )}

      <div
        className={clsx(styles.rmpmContainer, {
          [styles.fullHeight]: uiConfig.containerClass === "fullHeight",
          [styles.fullHeightWeekly]:
            uiConfig.containerClass === "fullHeightWeekly",
          [styles.fullHeightSupplierInsights]:
            uiConfig.containerClass === "fullHeightSupplierInsights",
          // [styles.rmpmAlertHeight]: uiConfig.containerClass === 'rmpmAlertHeight',
        })}
      >
        <div className={styles.rmpmTableBody}>
          <div className={styles.filters}>
            {state[viewType === "MAI View" ? "maiFilters" : "rmpmFilters"]
              .filter((filter) => filter.isFavourite)
              .map((filter) => (
                <ListItem key={filter.label} className={styles.listCustomClass}>
                  <Multiselectwithsearchinput
                    key={filter.label}
                    label={filter.label}
                    options={filter.data}
                    filterValues={filter.selectedData}
                    handleFilter={(label, values) =>
                      handleMultiSelectChange(
                        label,
                        values,
                        viewType === "MAI View",
                      )
                    }
                    disabled={false}
                    type={alertType}
                  />
                </ListItem>
              ))}
            {viewType === "MAI View" && (
              <ListItem key="weeks" className={styles.listCustomClass}>
                <Multiselectwithsearchinput
                  key="Week"
                  label="Week"
                  options={state.weekNum}
                  filterValues={[]}
                  handleFilter={(label, values) => weekColFilter(label, values)}
                  disabled={false}
                  type={alertType}
                />
              </ListItem>
            )}
            <div
              style={{
                paddingLeft: "5px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <button
                type="button"
                onClick={resetFilter}
                aria-label="Reset Filters"
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={resetBtn}
                  alt="Reset Filters"
                />
              </button>
              <OverflowMenu
                menuItems={[
                  {
                    label: "More Filters",
                    icon: Filters,
                    onClick: handleFilterDrawer,
                  },
                  {
                    label: "Customise",
                    icon: Slider,
                    onClick: handleCustomizeDrawer,
                  },
                  {
                    label: "Export",
                    icon: Excel,
                    onClick: exportToExcel,
                  },
                ]}
              />
            </div>
          </div>

          {/* {viewType === 'Detailed view' && ( */}
          <div className={styles.filtersBtnContainer}>
            <Box className={styles.chipContainer}>
              {state[viewType === "MAI View" ? "maiFilters" : "rmpmFilters"]
                .filter(
                  (filter) =>
                    !filter.isFavourite && filter.selectedData?.length,
                )
                .map((filter) => (
                  <div key={filter.label}>
                    {filter.selectedData.map((selectedValue, subIndex) => (
                      <Chip
                        key={`${filter.label}-${String(selectedValue)}`}
                        label={selectedValue}
                        onDelete={() =>
                          handleMultiSelectChange(
                            filter.label,
                            removeArrayItemAtIndex(filter.selectedData, subIndex),
                            isMAIView,
                          )
                        }
                      />
                    ))}
                  </div>
                ))}
            </Box>
          </div>
          {/* )} */}

          {uiConfig.showToogleButton && (
            <div className={styles.toggleBtnContainer}>
              <StyledToggleButtonGroup
                color="primary"
                value={viewType}
                exclusive
                onChange={handleToggleBtnChange}
                aria-label="Platform"
                size="small"
              >
                {uiConfig.toggleBtn.map((details) => (
                  <ToggleButton key={details} value={details}>
                    {details}
                  </ToggleButton>
                ))}
              </StyledToggleButtonGroup>
            </div>
          )}

          {isTableComponent2View ? (
            <TableComponent2
              data={table2Data}
              columnList={table2Columns}
              type={alertType}
              viewType={viewType}
              loading={state.loading}
            />
          ) : (
            <TableComponent
              data={state.filteredData}
              supplierInsights={state.supplierInsights}
              vendorQCIndex={state.vendorQCIndex}
              overduePO={state.overduePO}
              leadTimeAnalysis={state.leadTimeAnalysis}
              sobCompliance={state.sobCompliance}
              columnList={state.columnList}
              viewType={viewType}
              type={alertType}
              loading={state.loading}
            />
          )}
        </div>
      </div>

      {snackBarObject.snackbarOpen && (
        <SnackBarMessage
          type={snackBarObject.type}
          snackbarMessage={snackBarObject.message}
          snackbarOpen={snackBarObject.snackbarOpen}
          setSnackbarOpen={closeSnackbar}
        />
      )}

      {uiConfig.showFooter && (
        <div className={styles.rmpmFooter}>
          <div className={styles.btnContainer}>
            {uiConfig.showReviewCart && (
              <CustomButton
                label="Review Cart"
                type="cart"
                disabled={selectedRecomLength === 0}
                onClick={toggleDrawer(true)}
              />
            )}
            <CustomButton
              label="Submit"
              count={selectedRecomLength}
              type="submit"
              disabled={selectedRecomLength === 0}
              onClick={handleSubmit}
            />
          </div>
        </div>
      )}

      {uiConfig.showReviewCart && (
        <Drawer
          anchor="right"
          open={state.drawerState}
          onClose={toggleDrawer(false)}
          sx={{ "& .MuiDrawer-paper": { width: "75%" } }}
        >
          <ReviewCart onClose={toggleDrawer(false)} type={alertType} />
        </Drawer>
      )}

      {uiConfig.showActionPopup && (
        <ActionPopup
          open={state.openPopup}
          onClose={() => setState((prev) => ({ ...prev, openPopup: false }))}
          type={alertType}
        />
      )}

      {uiConfig.showCustomizeColumns && state.isDrawerOpen && (
        <CustomiseColumns
          anchor="right"
          columns={
            viewType === "MAI View" ? state.maiDetailsColumns : state.columnList
          }
          isOpen={state.isDrawerOpen}
          handleCustomizeDrawer={handleCustomizeDrawer}
          columnCustomization={columnCustomization}
          username={activeAccount.username}
          type={alertType}
        />
      )}

      {uiConfig.showMoreFilters && state.filterDrawer && (
        <MoreFilters
          anchor="right"
          filterDrawer={state.filterDrawer}
          handleFilterDrawer={handleFilterDrawer}
          rmpmFilters={
            viewType === "MAI View" ? state.maiFilters : state.rmpmFilters
          }
          setRmpmFilters={updateFiltersFromDrawer}
          username={activeAccount.username}
          type={alertType}
        />
      )}

      {/* Codes for Samarth Chat Bot */}
      {uiConfig?.showChatBot === <ChatBot />}
    </>
  );
};

AlertLanding.propTypes = {
  alertType: PropTypes.oneOf(['RMPM Alert', 'Norm Alert', 'Contract Alert', 'Contract PR2 Alert', 'Agile OR', 'Weekly OR', 'Or Loss Tree', 'Supplier Insights', 'FG Coverage', 'Manpower Shortage']).isRequired,
};

export default React.memo(AlertLanding);